import { Form, FormInstance } from 'antd';
import Text from 'components/Text';
import styled from 'styled-components';
import colorTheme from 'constants/color';
import StaffRow from './StaffRow';
import { AddStaffSaleFormValues } from './AddStaffSaleModal';
import { formatCurrency } from 'utils/formatCurrency';
import { IStaffItemData } from 'services/shop/types/staff';
import { useCallback } from 'react';

interface TableStaffSaleProps {
  form: FormInstance<AddStaffSaleFormValues>;
}

const TableStaffSale = ({ form }: TableStaffSaleProps) => {
  const staffs = Form.useWatch('staffs', form) || [];

  const totalAmount = staffs.reduce((total, staff) => total + (staff.amount || 0), 0);
  const filterStaff = useCallback(
    (list: IStaffItemData[]) => {
      return list.filter((o) => !o.anyBody && staffs?.findIndex((s) => o.id === s.staffId) === -1);
    },
    [staffs],
  );
  
  return (
    <Form.List name={'staffs'}>
      {(fields, { add, remove }) => {
        return (
          <>
            <div className='table-wrapper'>
              <TableStyled className='table-container'>
                <thead className='table-thead'>
                  <tr>
                    <th className='service-th'>
                      <div className='container-box'>
                        <span>SERVICE NAME</span>
                      </div>
                    </th>
                    <th className='staff-th'>
                      <div className='container-box'>
                        <span>STAFF</span>
                      </div>
                    </th>
                    <th>
                      <div className='container-box'>
                        <span>PRICE</span>
                      </div>
                    </th>
                    <th className='action'>
                      <div className='container-box'>
                        <span>ACTION</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className='table-tbody'>
                  {fields.map((field) => (
                    <StaffRow
                      key={field.key}
                      name={field.name}
                      remove={() => remove(field.name)}
                      filterStaff={filterStaff}
                    />
                  ))}
                </tbody>
                <tfoot>
                  <tr className='thead-total-row'>
                    <th>
                      <div className='container-box'>
                        <Text variant='H1'>Total</Text>
                      </div>
                    </th>
                    <th>
                      <div className='container-box' />
                    </th>
                    <th>
                      <div className='container-box center'>
                        <Text variant='H1'>{formatCurrency(totalAmount)}</Text>
                      </div>
                    </th>
                    <th className='action'>
                      <div className='container-box' />
                    </th>
                  </tr>
                </tfoot>
              </TableStyled>
            </div>
          </>
        );
      }}
    </Form.List>
  );
};
export default TableStaffSale;

const TableStyled = styled.table`
  border-collapse: collapse;
  width: 100%;
  font-family: Poppins;
  &.table-container {
    .table-thead {
      tr {
        th {
          padding: 8px 12px;
          border-bottom: 1px solid ${colorTheme.v2_border_2};
          &.no-style {
            background: transparent;
          }
          span {
            font-size: 16px;
            color: ${colorTheme.text_3_v2};
          }
        }
        &.thead-total-row {
          font-size: 1.5rem;
          .container-box {
            text-align: right;
            justify-content: flex-end;
            padding-right: 12px;
          }
          th {
            height: 48px;
            padding: 0;
          }
        }
      }
    }
    th,
    td {
      position: relative;
      z-index: 1;
      min-width: 150px;
      &.staff-info {
        min-width: 280px;
      }
      &.action {
        min-width: 48px;
      }
      .container-box {
        background: transparent;
        display: flex;
        align-items: center;
        &.staff-col {
          justify-content: start;
        }

        &.center {
          justify-content: center;
        }
      }
      &.action {
        padding: 8px !important;
      }
    }

    th {
      height: 28px;
    }

    td {
      height: 64px;
      border-bottom: 1px solid ${colorTheme.v2_border_2};
    }

    .service-th {
      min-width: 240px;
    }

    .staff-th {
      min-width: 190px;
    }

    .table-tbody {
      tr {
        td {
          width: 100%;
          padding: 16px 12px;
          &.no-style {
            background: transparent;
          }
          &.staff-info {
            .CONTENT_2 {
              font-size: 1.2rem;
            }
          }
          .ant-input {
            height: 54px !important;
            text-align: center;
            font-size: 1.5rem;
            font-weight: 500;
            font-family: Poppins;
            &:disabled {
              // color: #1D2129;
              background: #fff;
            }
          }
        }
      }

      .btn-delete {
        height: 48px;
        width: 48px;
        border-radius: 8px;
        color: #fff;
        span {
          font-size: 1.5rem;
        }
      }
    }
  }
`;
